export const SANDBOX_BANNER_ID = 'root-nav-sandbox-banner';
export const SANDBOX_BANNER_GATE = 'sandboxes:banner:redesign';
export const SANDBOX_TYPE = {
  DEVELOPER: 'DEVELOPER',
  STANDARD: 'STANDARD'
};
export const SANDBOX_VERSION = {
  V1: 'V1',
  V2: 'V2'
};
export const LINKS = {
  deployConsiderations: 'https://knowledge.hubspot.com/account-management/assets-eligible-to-be-deployed-to-production'
};